import axios, { AxiosResponse } from 'axios';

export default function getInstrumentHistoryAsync(apiUrl: string) {
  return function api<TResponse>(
    instrumentId: string | undefined | null,
    serial: string | undefined | null,
    filters: { string: string } | undefined | null,
    sorting: string | undefined | null,
    skipCount: number | undefined | null,
    maxResultCount: number | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/instruments/${instrumentId}/history?serial=${serial}&filters=${filters}&sorting=${sorting}&skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
          method: 'GET',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
